
import Vue from 'vue'
import { firestorePlugin } from 'vuefire'
import firebase from 'firebase/app';
require('firebase/auth')
require('firebase/database')
require('firebase/firestore')
require('firebase/storage')
require("firebase/functions")

Vue.use(firebase)
Vue.use(firestorePlugin)


var config = {
    apiKey: "AIzaSyB8EgX0-_PM76Ja8WleSRdFDXeymGQe-hY",
    authDomain: "scouts-284.firebaseapp.com",
    databaseURL: "https://scouts-284.firebaseio.com",
    projectId: "scouts-284",
    storageBucket: "scouts-284.appspot.com",
    messagingSenderId: "867219610263"
};
firebase.initializeApp(config);

Vue.prototype.$db = firebase.firestore()
Vue.prototype.$storage = firebase.storage()
Vue.prototype.$firebase = firebase

//firebase.firestore().settings({timestampsInSnapshots: true});
//firebase.firestore().settings({});
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
firebase.auth().onAuthStateChanged(function(user) {
    if (user) {console.log("test")   }
});

export default firebase
